export const getNumberFromString = (cellKey: string): number => parseInt(cellKey.replace(/^\D+/g, ''))
export const removeNumbersFromString = (cellKey: string): string => cellKey.replace(/[0-9]/g, '')
